import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import theme, { makeStyles, ThemeColors, ThemeVars } from 'core/utilities/theme';
import type React from 'react';
import { useSelector } from 'react-redux';

interface MakeStylesProps {
  headerHeight: number;
}

const styles = makeStyles((props: MakeStylesProps) => ({
  grid: {
    height: '100%',
    minHeight: `calc(100vh - ${props.headerHeight} - ${ThemeVars.footerMaxHeight})`,
  },
  gridOnBlankPage: {
    minHeight: '100vh',
  },
  paper: {
    margin: theme.spacing(2),
    padding: theme.spacing(3),
    boxShadow: theme.shadows[4],
    borderColor: ThemeColors.darkBorderColor,
  },
}));

export function PaperPageContent({ children }: { children: React.ReactNode }) {
  const classes = styles({});

  return (
    <Paper sx={classes.paper}>
      {children}
    </Paper>
  );
}

interface ComponentProps {
  blankPage?: boolean;
  children: React.ReactNode;
  secondLevelChildren?: React.ReactNode;
}

export function PaperPage({
  children, blankPage = false, secondLevelChildren,
}: ComponentProps) {
  const showAppHeaderEnv = useSelector((state: ApplicationState) => state.ui.showAppHeaderEnv);

  let headerHeight = ThemeVars.headerMenuHeight;
  if (showAppHeaderEnv) headerHeight += ThemeVars.headerEnvHeight;

  const classes = styles({ headerHeight });

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      sx={blankPage ? classes.gridOnBlankPage : classes.grid}
    >
      <Grid item xs={12} sm={10} md={7} sx={{ maxWidth: { lg: '650px' } }}>
        <PaperPageContent>
          {children}
        </PaperPageContent>
        {secondLevelChildren}
      </Grid>
    </Grid>
  );
}

export default PaperPage;
